export default __webpack_public_path__ + "static/media/pic8.1997b762.png";